import { CookieUtil } from "./CookieUtil";
import { CookieConstantKey } from "./CookieConstantKey";

export default class FilaContribuicaoUtil {
  public static temFila() {
    const fila = CookieUtil.getCookie(CookieConstantKey.FILA_CONTRIBUICAO);
    return !!fila && fila.length > 0;
  }

  public static getFila() {
    const fila = CookieUtil.getCookie(CookieConstantKey.FILA_CONTRIBUICAO);
    if (!fila || fila.length <= 0) {
      return [];
    }
    return fila;
  }

  public static setFila(fila: any) {
    CookieUtil.setCookie(CookieConstantKey.FILA_CONTRIBUICAO, fila, 1);
  }

  public static limparFila() {
    CookieUtil.setCookie(CookieConstantKey.FILA_CONTRIBUICAO, [], 1);
  }

  public static removerItemFila(item: any) {
    let fila = FilaContribuicaoUtil.getFila();
    if (!fila || fila.length <= 0) {
      return false;
    }
    fila = [...fila];
    fila = fila.filter((m: any) => m != item);
    FilaContribuicaoUtil.setFila([...fila]);
    return true;
  }

  private static readonly RELOAD_DELAY_MS = 1000;

  private static getRoutes(isInterno: boolean) {
    return isInterno
      ? {
          visualizar: "/evento-interno",
          contribuicao: "/evento-interno-contribuicao",
        }
      : {
          visualizar: "/evento/visualizar",
          contribuicao: "/evento/contribuicao",
        };
  }

  private static navigateToNext(
    history: any,
    fila: any[],
    codAudienciaPublica: any,
    routes: { visualizar: string; contribuicao: string }
  ) {
    if (fila.length <= 0) {
      history.push(routes.visualizar, { id: codAudienciaPublica });
      return;
    }

    history.push(routes.contribuicao, {
      id: fila[0],
      codAudienciaPublica: codAudienciaPublica,
    });

    // setTimeout(() => {
    //   history.go(0);
    // }, FilaContribuicaoUtil.RELOAD_DELAY_MS);
  }

  public static goToNext(history: any, id: any, codAudienciaPublica: any) {
    const isIdInterno = !!sessionStorage.getItem("idEventoInterno");
    const routes = FilaContribuicaoUtil.getRoutes(isIdInterno);

    if (!FilaContribuicaoUtil.temFila()) {
      history.push(routes.visualizar, { id: codAudienciaPublica });
      return;
    }

    FilaContribuicaoUtil.removerItemFila(id);
    const fila = FilaContribuicaoUtil.getFila();

    FilaContribuicaoUtil.navigateToNext(
      history,
      fila,
      codAudienciaPublica,
      routes
    );
  }
}
